export const WHITE_LABEL_API_VERSION = "v2";
